import { Props } from 'shared/@types';
import { View } from 'react-native';
import { clsx } from 'clsx';

export function PageContent({
  children,
  className,
  contentClassName,
  nativeSafeTop: _nativeSafeTop,
  nativeFlushTop: _nativeFlushTop,
  nativeFlushBottom: _nativeFlushBottom,
}: Props<{
  contentClassName?: string;
  nativeSafeTop?: boolean;
  nativeFlushTop?: boolean;
  nativeFlushBottom?: boolean;
}>) {
  return (
    <View className={clsx('px-3 py-3 md:px-6 md:py-12', className)}>
      <View className={clsx('mx-auto w-full max-w-screen-xl', contentClassName)}>{children}</View>
    </View>
  );
}
